import { Component, OnInit } from '@angular/core';
import { RiskWarningService } from '../../services/risk-warnings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AvisosRiesgos, AvisosList } from '../../interfaces';
import { Router } from '@angular/router';
import { ToastrService } from '../ui/toastr/toastr.service';
import { IButtonTable, ColLabel } from '../table/table.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RiskWarningModalComponent } from 'src/app/modules/risk-warning-modal/risk-warning-modal.component';
import { UtilService } from 'src/app/services/util.service';
@Component({
  selector: 'app-risk-warning',
  templateUrl: './risk-warning.component.html'
})
export class RiskWarningComponent implements OnInit {
  destroyed$: Subject<boolean> = new Subject<boolean>();

  isLoading = true;

  data: AvisosRiesgos;

  avisosModificados: number;
  avisosPendientes: number;
  avisosCancelados: number;

  avisosList: AvisosList[];

  colsTable: ColLabel[] = [];

  constructor(
    private warningsService: RiskWarningService,
    private router: Router,
    private utilService: UtilService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.warningsService
      .getWarningsList()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        res => {
          this.data = res.data;
          this.avisosModificados = this.data.avisosModificados;
          this.avisosPendientes = this.data.avisosPendientes;
          this.avisosCancelados = this.data.avisosCancelados;
          this.avisosList = this.data.avisosList;
          this.colsTable = [
            {
              label: 'CUSTOMERS.BUSSINES_NAME',
              field: ['razonSocial'],
              fieldClass: [''],
              action: ''
            },
            {
              label: 'RISK_WARNINGS.CIF',
              field: ['cif'],
              fieldClass: [''],
              action: ''
            },
            {
              label: 'RISK_WARNINGS.STATE',
              field: ['estado'],
              fieldClass: [''],
              action: ''
            },
            {
              label: '',
              field: [''],
              fieldClass: ['button'],
              action: 'openWarning',
              nameIcon: 'eye'
            }
          ];
          this.isLoading = false;
        },
        error => {
          this.utilService.toastErrors(error);
        }
      );
  }

  public handleButton(value: IButtonTable): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      disableClose: true,
      autoFocus: false,
      panelClass: ['modal__full-screen'],
      data: { value: value.data }
    };
    this.dialog.open(RiskWarningModalComponent, dialogConfig.data);
  }

  public handleNavigate(): void {
    this.router.navigate(['customers'], { queryParams: { tab: 2 } });
  }
}
